import offerActionTypes from '../../../../store/componentStores/Offer/offer.types';
import plansActionTypes from '../../../../store/componentStores/Plans/plans.types';
import { logOfferCodeError } from '../../../../utilities/analytics';
import { getOfferCodeErrorDetails } from '../../../../utilities/planUtils';

export const onOfferCodeError = ({ type, offerCodeError, errorMessage, getState }) => {
  const isOfferCodeError = type === offerActionTypes.ON_OFFER_CODE_ERROR;
  const isAvailabilityError = type === plansActionTypes.GET_PLANS_AVAILABILITY_INFO_SUCCESS;
  const shouldLogOfferCodeError = isOfferCodeError || isAvailabilityError;

  if (!shouldLogOfferCodeError) return;

  if (isAvailabilityError) {
    const { dates: { checkinDateSelection, checkoutDateSelection } = {} } = getState();
    const { errorCode, offerCode } = offerCodeError || {};

    const offerCodeErrorMessage = getOfferCodeErrorDetails({
      offerCode,
      offerCodeError: errorCode,
      checkIn: checkinDateSelection,
      checkOut: checkoutDateSelection
    });

    if (offerCodeErrorMessage && offerCodeErrorMessage.message) {
      logOfferCodeError(offerCodeErrorMessage.message);
    }
  }

  if (isOfferCodeError) {
    logOfferCodeError(errorMessage);
  }
};
